module.exports = __webpack_public_path__ + "static/media/open.1794c984.svg";